<template>
  <div class="view">
    <keep-alive :include="cachedViews">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'SuperiorJrttContainer',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
  },
};
</script>

<style rel="stylesheet/scss"  lang="scss" scoped>
.view {
  padding: 20px;
  background: #f5f6f7;
}
/deep/ .el-drawer__body {
  padding: 0 20px 20px;
}
</style>
